// extracted by mini-css-extract-plugin
export var fadeIn = "_g6-1";
export var modalContent = "_g6-3";
export var overlay = "_g6-0";
export var popoverContent = "_g6-2";
export var results = "_g6-5";
export var searchInputWrapper = "_g6-4";